import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/TwoColumnWithInput.js";
import Features from "components/features/ThreeColWithSideImage.js";
import Features2 from "components/features/ThreeColSimple.js";
import VerticalWithAlternateImageAndText from "components/features/TwoColSingleFeatureWithStats3.js";
import MainFeature from "components/features/TwoColWithButton.js";
import MainFeature2 from "components/features/TwoColWithTwoHorizontalFeaturesAndButton.js";
import MainFeature3 from "components/features/TwoColWithTwoHorizontalFeaturesAndButton3.js";
import MainFeature4 from "components/features/TwoColWithTwoHorizontalFeaturesAndButton4.js";
import FeatureWithSteps from "components/features/TwoColWithSteps.js";
import Pricing from "components/pricing/ThreePlans.js";
import Testimonial from "components/testimonials/TwoColumnWithImageAndRating.js";
import FAQ from "components/faqs/SingleCol.js";
import GetStarted from "components/cta/GetStarted";
import Roadmap from "components/pricing/ThreePlans.js";


import DashedBorderSixFeatures from "components/features/DashedBorderSixFeatures.js";


import Footer from "components/footers/MiniCenteredFooter.js";
import macHeroScreenshotImageSrc from "images/hero-screenshot-2.png";
import prototypeIllustrationImageSrc from "images/dao.png";
import prototypeIllustrationImageSrc2 from "images/trades.png";
import prototypeIllustrationImageSrc3 from "images/babykraken_only_550px-min.png";
import { ReactComponent as BriefcaseIcon } from "feather-icons/dist/icons/briefcase.svg";
import { ReactComponent as MoneyIcon } from "feather-icons/dist/icons/check.svg";

export default () => {
  const Subheading = tw.span`uppercase tracking-widest font-bold text-green-500`;
  const HighlightedText = tw.span`text-green-500`;

  return (
    <AnimationRevealPage>



      <Hero roundedHeaderButton={true} />



        <VerticalWithAlternateImageAndText/>


        <MainFeature3
          subheading={<Subheading>ANTI-BOT PROTECTION</Subheading>}
          heading={
            <>
              BabyKraken <HighlightedText>fixed</HighlightedText> the transaction spam exploit.
            </>
          }
          imageSrc={prototypeIllustrationImageSrc2}
          showDecoratorBlob={false}
          features={[
            {
              Icon: MoneyIcon,
              title: "Buyback Threshold",
              description: "If the buyback amount is 0.01 BNB and someone sells for 0.001 BNB, the contract will buyback the same amount you sold for instead for the full 0.01 BNB",
              iconContainerCss: tw`bg-green-300 text-green-800`
            },
            {
              Icon: MoneyIcon,
              title: "Time Gated Buyback",
              description: "An exploiter would spam transactions with a low amount to empty the buyback treasury. In addition to the buyback threshold we also implemented a 3 second time gate for buybacks below the threshold to tackle this.",
              iconContainerCss: tw`bg-green-300 text-green-800`
            }
          ]}
        />


        <MainFeature4
          subheading={<Subheading>Buy Back Treasury</Subheading>}
          heading={
            <>
              BabyKraken <HighlightedText>guards</HighlightedText> the price of $KRAKBABY. Only the <HighlightedText>holders</HighlightedText> of $KRAKBABY have the power to <HighlightedText>awaken </HighlightedText>him.
            </>
          }
          imageSrc={prototypeIllustrationImageSrc3}
          showDecoratorBlob={false}

        />

        <DashedBorderSixFeatures/>





      <Features2
        subheading={<Subheading>Tokenomics</Subheading>}
        heading={
          <>
            BabyKraken has the perfect <HighlightedText>Taxes.</HighlightedText>
          </>
        }
      />

      <MainFeature2
        subheading={<Subheading>DECENTRALIZATION & COMMUNITY</Subheading>}
        heading={
          <>
            BabyKraken Contract <HighlightedText>Ownership.</HighlightedText>
          </>
        }
        imageSrc={prototypeIllustrationImageSrc}
        showDecoratorBlob={false}
        features={[
          {
            Icon: MoneyIcon,
            title: "Decentralized",
            description: "Those who care the most about the protocol - our holders - hold the power to make decisions on the protocol's future.",
            iconContainerCss: tw`bg-green-300 text-green-800`
          },
          {
            Icon: MoneyIcon,
            title: "Secure & Battleproof",
            description: "Our DAO technology, one of the first of its kind on BSC, is fully audited and battleproofed through use on the ETH blockchain. Be part of the wisdom of the crowd",
            iconContainerCss: tw`bg-green-300 text-green-800`
          }
        ]}
      />

      <Roadmap/>




      <FeatureWithSteps
        subheading={<Subheading>STEPS</Subheading>}
        heading={
          <>
            How to <HighlightedText>Buy</HighlightedText>
          </>
        }
        textOnLeft={false}
        imageSrc={macHeroScreenshotImageSrc}
        imageDecoratorBlob={true}
        decoratorBlobCss={tw`xl:w-40 xl:h-40 opacity-15 -translate-x-1/2 left-1/2`}
      />



      <FAQ
        subheading={<Subheading>FAQS</Subheading>}
        heading={
          <>
            You have <HighlightedText>Questions ?</HighlightedText>
          </>
        }
        faqs={[
          {
            question: "How can I buy the presale?",
            answer:
              "PC: Connect Metamask to the BSC Network. go to the DXSALE presale page and buy with BNB. Smartphone: Open TrustWallet, go to DAPPS and paste the DXSALE presale url into it. Make sure you are connected to the BSC Network."
          },
          {
            question: "How can I buy BabyKraken?",
            answer:
              "Download TrustWallet or MetaMask, register on Binance and purchase BNB. Click the buy button on this page and you will be redirected to PancakeSwapV2. Click 'I understand' and purchase the desired amount."
          },
          {
            question: "What is the marketing for BabyKraken?",
            answer:
              "Initial marketing plans right after launch: Paid promotion/ads: CoinMooner, CoinSniper, CoinHunt, Poocoin, Bogged.finance, 4chan /biz/. 5 Twitter influencers, 2 TG channels with each ~20k subsribers. and more!"
          },
          {
            question: "Is the BabyKraken contract secure?",
            answer:
              "Yes. it's a fork of EverRise which is audited, combined with the liquidity tax mechanism which has been copied 1:1 from safemoon. To solve the bot problem, we only had to write less than 10 lines of codes. You can check the difference to the EverRise contract in our Wiki."
          },
        ]}
      />
      <Footer />
    </AnimationRevealPage>
  );
}
